module.exports = __webpack_public_path__ + "resources/images/ing-a80dff3918528fa55e6302bad294b297-cache.png";